import MatterStage from "../../entities/matterStage";

/**
 * MatterStage actions
 *
 * Call order:
 *
 * MATTERSTAGE_SAVE_QUEUE:	adds the item to the save queue
 * --> MATTERSTAGE_SAVE:	modifies the state
 * --> MATTERSTAGE_SAVE_SUCCESS: if all went well
 * --> MATTERSTAGE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail MATTERSTAGE_SAVE_QUEUE is during the call to MATTERSTAGE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const MATTERSTAGE_FETCH_ONE_QUEUE: any = 'MATTERSTAGE_FETCH_ONE_QUEUE';
export const MATTERSTAGE_FETCH_SUCCESS: any = 'MATTERSTAGE_FETCH_SUCCESS';
export const MATTERSTAGE_FETCH_FAILURE: any = 'MATTERSTAGE_FETCH_FAILURE';
export const MATTERSTAGE_FETCH_ONE_SUCCESS: any = 'MATTERSTAGE_FETCH_ONE_SUCCESS';
export const MATTERSTAGE_FETCH_ONE_FAILURE: any = 'MATTERSTAGE_FETCH_ONE_FAILURE';

export const MATTERSTAGE_SAVE: any = 'MATTERSTAGE_SAVE';
export const MATTERSTAGE_SAVE_QUEUE: any = 'MATTERSTAGE_SAVE_QUEUE';
export const MATTERSTAGE_SAVE_SUCCESS: any = 'MATTERSTAGE_SAVE_SUCCESS';
export const MATTERSTAGE_SAVE_FAILURE: any = 'MATTERSTAGE_SAVE_FAILURE';

export const MATTERSTAGE_SAVE_MANY: any = 'MATTERSTAGE_SAVE_MANY';
export const MATTERSTAGE_SAVE_MANY_QUEUE: any = 'MATTERSTAGE_SAVE_MANY_QUEUE';
export const MATTERSTAGE_SAVE_MANY_SUCCESS: any = 'MATTERSTAGE_SAVE_MANY_SUCCESS';
export const MATTERSTAGE_SAVE_MANY_FAILURE: any = 'MATTERSTAGE_SAVE_MANY_FAILURE';

export const MATTERSTAGE_REMOVE: any = 'MATTERSTAGE_REMOVE';
export const MATTERSTAGE_REMOVE_QUEUE: any = 'MATTERSTAGE_REMOVE_QUEUE';
export const MATTERSTAGE_REMOVE_SUCCESS: any = 'MATTERSTAGE_REMOVE_SUCCESS';
export const MATTERSTAGE_REMOVE_FAILURE: any = 'MATTERSTAGE_REMOVE_FAILURE';

export const MATTERSTAGE_RESTORE: any = 'MATTERSTAGE_RESTORE';
export const MATTERSTAGE_RESTORE_QUEUE: any = 'MATTERSTAGE_RESTORE_QUEUE';
export const MATTERSTAGE_RESTORE_SUCCESS: any = 'MATTERSTAGE_RESTORE_SUCCESS';
export const MATTERSTAGE_RESTORE_FAILURE: any = 'MATTERSTAGE_RESTORE_FAILURE';

export const MATTERSTAGE_RESTORE_MANY: any = 'MATTERSTAGE_RESTORE_MANY';
export const MATTERSTAGE_REMOVE_MANY: any = 'MATTERSTAGE_REMOVE_MANY';

/* Fetch actions */
export const fetchMatterStageSuccess = (matterStages: MatterStage[], partial: boolean, lastFetch: number) => ({type: MATTERSTAGE_FETCH_SUCCESS, matterStages, partial, lastFetch});
export const fetchMatterStageFailure = (err: any) => {
		console.error('MatterStageAction: fetchMatterStageFailure', err);
		return {type: MATTERSTAGE_FETCH_FAILURE, err};
};
export const fetchOneMatterStageQueue = (matterStageId: string) => ({type: MATTERSTAGE_FETCH_ONE_QUEUE, matterStageId});
export const fetchOneMatterStageSuccess = (matterStage: MatterStage) => ({type: MATTERSTAGE_FETCH_ONE_SUCCESS, matterStage});
export const fetchOneMatterStageFailure = (id: string, err: any) => {
		console.error('MatterStageAction: fetchOneMatterStageFailure', err);
		return {type: MATTERSTAGE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveMatterStage = (matterStage: MatterStage) => {
    // console.debug('⮂ MATTERSTAGE_SAVE action', matterStage?.id);
    return {type: MATTERSTAGE_SAVE, matterStage};
}
export const saveMatterStageQueue = (matterStage: MatterStage, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ MATTERSTAGE_SAVE_QUEUE action', matterStage?.id);
    return {type: MATTERSTAGE_SAVE_QUEUE, matterStage, onQueued};
}
export const saveMatterStageSuccess = (matterStage: MatterStage) => {
    // console.debug('⮂ MATTERSTAGE_SAVE_SUCCESS action', matterStage?.id);
    return {type: MATTERSTAGE_SAVE_SUCCESS, matterStage};
}
export const saveMatterStageFailure = (matterStage: MatterStage, status: number, message: string) => {
    console.warn(`⮂ MATTERSTAGE_SAVE_FAILURE error saving matterStage: HTTP ${status}: ${message}`, matterStage?.id);
    return {type: MATTERSTAGE_SAVE_FAILURE, matterStage, status, message};
};

/* SaveMany actions */
export const saveManyMatterStages = (matterStages: MatterStage[]) => {
    // console.debug('⮂ MATTERSTAGE_SAVE_MANY action', matterStages?.map(matterStage => matterStage?.id).join(','));
    return {type: MATTERSTAGE_SAVE_MANY, matterStages};
}
export const saveManyMatterStagesQueue = (matterStages: MatterStage[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ MATTERSTAGE_SAVE_MANY_QUEUE action', matterStages?.map(matterStage => matterStage.id).join(','));
    return {type: MATTERSTAGE_SAVE_MANY_QUEUE, matterStages, onQueued};
}

export const saveManyMatterStagesSuccess = (matterStages: MatterStage[]) => {
    // console.debug('⮂ MATTERSTAGE_SAVE_MANY_SUCCESS action', matterStages?.map(matterStage => matterStage.id).join(','));
    return {type: MATTERSTAGE_SAVE_MANY_SUCCESS, matterStages};
}
export const saveManyMatterStagesFailure = (matterStages: MatterStage[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_MATTERSTAGES_FAILURE Error saving matterStages: HTTP ${status}: ${message}`, matterStages?.map(matterStage => matterStage.id).join(','));
		return {type: MATTERSTAGE_SAVE_MANY_FAILURE, matterStages, status, message};
};

/* Remove actions */
export const removeMatterStage = (matterStage: MatterStage) => ({ type: MATTERSTAGE_REMOVE, matterStage });
export const removeMatterStageQueue = (matterStage: MatterStage) => ({ type: MATTERSTAGE_REMOVE_QUEUE, matterStage });
export const removeMatterStageSuccess = (matterStage: MatterStage) => ({ type: MATTERSTAGE_REMOVE_SUCCESS, matterStage });
export const removeMatterStageFailure = (matterStage: MatterStage, status: number, message: string) => {
	console.error(`Redux: removeMatterStageFailure Error removing matterStage: HTTP ${status}: ${message}`);
	return ({ type: MATTERSTAGE_REMOVE_FAILURE, matterStage, status, message });
};

/* Restore actions */
export const restoreMatterStage = (matterStage: MatterStage) => ({ type: MATTERSTAGE_RESTORE, matterStage });
export const restoreMatterStageQueue = (matterStage: MatterStage) => ({ type: MATTERSTAGE_RESTORE_QUEUE, matterStage });
export const restoreMatterStageSuccess = (matterStage: MatterStage) => ({ type: MATTERSTAGE_RESTORE_SUCCESS, matterStage });
export const restoreMatterStageFailure = (matterStage: MatterStage, status: number, message: string) => {
	console.error(`Redux: restoreMatterStageFailure Error restoring matterStage: HTTP ${status}: ${message}`);
	return ({ type: MATTERSTAGE_RESTORE_FAILURE, matterStage, status, message });
};

/* RestoreMany actions */
export const restoreManyMatterStages = (matterStages: MatterStage[]) => ({ type: MATTERSTAGE_RESTORE_MANY, matterStages });

/* RemoveMany actions */
export const removeManyMatterStages = (matterStages: MatterStage[]) => ({ type: MATTERSTAGE_REMOVE_MANY, matterStages });